"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const graphql_1 = require("../../graphql");
const useMappingCanvas_1 = require("./hooks/useMappingCanvas");
exports.MappingCanvasLoader = () => {
    const { data: { contentMappingId }, } = useMappingCanvas_1.useMappingCanvas('pathParams');
    return (react_2.default.createElement(react_1.OsmosysCanvasPageQueryLoader, { query: graphql_1.contentMapping, name: "contentMapping", variables: {
            id: parseInt(contentMappingId, 10),
        } }));
};
//# sourceMappingURL=MappingCanvasLoader.js.map